import React from 'react';
import { FilterIcon, RefreshCwIcon } from 'lucide-react';
interface FilterPanelProps {
  filters: {
    country: string;
    purpose: string;
    technology: string;
    minLaunchYear: number;
    maxLaunchYear: number;
  };
  setFilters: React.Dispatch<React.SetStateAction<{
    country: string;
    purpose: string;
    technology: string;
    minLaunchYear: number;
    maxLaunchYear: number;
  }>>;
  availableCountries: string[];
  availablePurposes: string[];
  availableTechnologies: string[];
  minYear: number;
  maxYear: number;
}
const FilterPanel: React.FC<FilterPanelProps> = ({
  filters,
  setFilters,
  availableCountries,
  availablePurposes,
  availableTechnologies,
  minYear,
  maxYear
}) => {
  const resetFilters = () => {
    setFilters({
      country: 'all',
      purpose: 'all',
      technology: 'all',
      minLaunchYear: minYear,
      maxLaunchYear: maxYear
    });
  };
  return <div className="space-y-6" data-id="element-15">
      <div className="flex items-center justify-between" data-id="element-16">
        <h2 className="text-xl font-semibold flex items-center" data-id="element-17">
          <FilterIcon className="mr-2" size={20} data-id="element-18" />
          Filters
        </h2>
        <button onClick={resetFilters} className="flex items-center text-sm text-blue-400 hover:text-blue-300" data-id="element-19">
          <RefreshCwIcon size={14} className="mr-1" data-id="element-20" />
          Reset
        </button>
      </div>
      <div className="space-y-4" data-id="element-21">
        <div data-id="element-22">
          <label className="block text-sm font-medium mb-2" data-id="element-23">Country</label>
          <select className="w-full bg-gray-800 border border-gray-700 rounded px-3 py-2 text-sm" value={filters.country} onChange={e => setFilters({
          ...filters,
          country: e.target.value
        })} data-id="element-24">
            <option value="all" data-id="element-25">All Countries</option>
            {availableCountries.map(country => <option key={country} value={country} data-id="element-26">
                {country}
              </option>)}
          </select>
        </div>
        <div data-id="element-27">
          <label className="block text-sm font-medium mb-2" data-id="element-28">Purpose</label>
          <select className="w-full bg-gray-800 border border-gray-700 rounded px-3 py-2 text-sm" value={filters.purpose} onChange={e => setFilters({
          ...filters,
          purpose: e.target.value
        })} data-id="element-29">
            <option value="all" data-id="element-30">All Purposes</option>
            {availablePurposes.map(purpose => <option key={purpose} value={purpose} data-id="element-31">
                {purpose}
              </option>)}
          </select>
        </div>
        <div data-id="element-32">
          <label className="block text-sm font-medium mb-2" data-id="element-33">Technology</label>
          <select className="w-full bg-gray-800 border border-gray-700 rounded px-3 py-2 text-sm" value={filters.technology} onChange={e => setFilters({
          ...filters,
          technology: e.target.value
        })} data-id="element-34">
            <option value="all" data-id="element-35">All Technologies</option>
            {availableTechnologies.map(tech => <option key={tech} value={tech} data-id="element-36">
                {tech}
              </option>)}
          </select>
        </div>
        <div data-id="element-37">
          <label className="block text-sm font-medium mb-2" data-id="element-38">
            Launch Year Range
          </label>
          <div className="flex items-center space-x-2" data-id="element-39">
            <input type="number" min={minYear} max={filters.maxLaunchYear} value={filters.minLaunchYear} onChange={e => setFilters({
            ...filters,
            minLaunchYear: parseInt(e.target.value)
          })} className="w-full bg-gray-800 border border-gray-700 rounded px-3 py-2 text-sm" data-id="element-40" />
            <span data-id="element-41">to</span>
            <input type="number" min={filters.minLaunchYear} max={maxYear} value={filters.maxLaunchYear} onChange={e => setFilters({
            ...filters,
            maxLaunchYear: parseInt(e.target.value)
          })} className="w-full bg-gray-800 border border-gray-700 rounded px-3 py-2 text-sm" data-id="element-42" />
          </div>
        </div>
      </div>
      <div className="pt-4 border-t border-gray-700" data-id="element-43">
        <h3 className="text-lg font-medium mb-2" data-id="element-44">Legend</h3>
        <div className="space-y-2 text-sm" data-id="element-45">
          <div className="flex items-center" data-id="element-46">
            <span className="w-3 h-3 bg-green-500 rounded-full mr-2" data-id="element-47"></span>
            <span data-id="element-48">Communication</span>
          </div>
          <div className="flex items-center" data-id="element-49">
            <span className="w-3 h-3 bg-yellow-500 rounded-full mr-2" data-id="element-50"></span>
            <span data-id="element-51">Navigation</span>
          </div>
          <div className="flex items-center" data-id="element-52">
            <span className="w-3 h-3 bg-red-500 rounded-full mr-2" data-id="element-53"></span>
            <span data-id="element-54">Military</span>
          </div>
          <div className="flex items-center" data-id="element-55">
            <span className="w-3 h-3 bg-blue-500 rounded-full mr-2" data-id="element-56"></span>
            <span data-id="element-57">Earth Observation</span>
          </div>
          <div className="flex items-center" data-id="element-58">
            <span className="w-3 h-3 bg-white rounded-full mr-2" data-id="element-59"></span>
            <span data-id="element-60">Other</span>
          </div>
        </div>
      </div>
    </div>;
};
export default FilterPanel;